module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_8_ba79afd169eda0f79a97b6d813fdb1e6.png";